import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { menuUrl } from "../inventory-item-list/model/item-list.constants";
import { createInventoryItem, getCategories, getManufacturers } from "./item-create.component.service";
import InventoryItemsTemplateCreateComponent from "./item-create-template.component";
import { getInventoryItemsInputs } from "../model/inventory-item.modal";
import { tableColumn } from "@screens/bug-tracker/bug-tracker-list/model/bug-tracker-list.constants";
import { PRIMARY_KEY } from "@constants/app.constants";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  ITEM_ALERTS: { CREATE_ALERT },
} = MESSAGES;

const InventoryItemsCreateComponent = () => {
const history = useHistory();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");

  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
    loading: true,
  });
  const [formInputs, setFormInputs] = useState([]);

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    if (errors.length > 0) return;

    let payload = {};
    values.forEach((field) => {
      payload[field.name] = field.value;
    });

    setFormTriggers({ ...formTriggers, loading: true });

    const response = await createInventoryItem(payload);

    setFormTriggers({ ...formTriggers, loading: false });

    if (response.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: CREATE_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(setAlertMessage({ type: ERROR, message: response.message }));
    }
  };

  const onLoad = async () => {
    const categoryResponse = await getCategories();
    const manufacturerResponse = await getManufacturers();

    if (categoryResponse.status && manufacturerResponse.status) {
      const formattedCategories = categoryResponse.data.map((cat) => ({
        name: cat.name,
        value: cat[PRIMARY_KEY], 
      }));

      const formattedManufacturers = manufacturerResponse.data.map((mfg) => ({
        name: mfg.manufacturer_name,
        value: mfg.manufacturer_name,
      }));

      const formInputData = getInventoryItemsInputs(formattedCategories, formattedManufacturers, {});
      setFormInputs(formInputData);
      setFormTriggers({ ...formTriggers, loading: false });
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  const templateModal = {
    formTriggers,
    formInputs,
    // tableData,
    tableColumn,
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <InventoryItemsTemplateCreateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default InventoryItemsCreateComponent;
